var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import { BImgLazy } from 'bootstrap-vue';
import round from 'lodash/round';
import { sprintf } from 'sprintf-js';
let MouldingSaleCard = class MouldingSaleCard extends Vue {
    constructor() {
        super(...arguments);
        this.round = round;
    }
    get itemCode() {
        let dotIndex = this.moulding.sku.indexOf('.');
        return this.moulding.sku.substr(dotIndex + 1, this.moulding.sku.length - (dotIndex + 1));
    }
    get altTag() {
        var _a, _b;
        return `${(_a = this.moulding.length.colour) === null || _a === void 0 ? void 0 : _a.name} ${(_b = this.moulding.length.profile) === null || _b === void 0 ? void 0 : _b.name} ${this.moulding.length.width_mm}mm Wide Picture Frame Moulding #${this.itemCode}`;
    }
    get price() {
        return sprintf('%02.2f', parseFloat(this.moulding.price));
    }
    get numMetres() {
        return round(this.moulding.num_metres, 2);
    }
};
__decorate([
    Prop(Object)
], MouldingSaleCard.prototype, "moulding", void 0);
MouldingSaleCard = __decorate([
    Component({
        components: {
            BImgLazy
        }
    })
], MouldingSaleCard);
export default MouldingSaleCard;
